import React from "react";
import {
  List,
  Datagrid,
  TextField,
  Pagination,
  FunctionField,
  EditButton,
  Button,
  Link,
  Responsive
} from "react-admin";
import CloseMaintenanceButton from "./closeMaintenanceButton";
import { isNil, path, isEmpty, head, prop } from "ramda";

import Add from "@material-ui/icons/Add";
import { CallMerge } from "@material-ui/icons";

const ListPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const rowStyle = record => ({
  backgroundColor: !isNil(record.lastLocation)
    ? path(["lastLocation", "color"], record)
    : ""
});

export const MaintenanceDueList = props => {
  return (
    <List
      {...props}
      title="Maintenances Due"
      resource="maintenances_due"
      pagination={<ListPagination />}
      bulkActionButtons={false}
      sort={{ field: "date", order: "ASC" }}
      key={Date.now()}
    >
      <Responsive
        small={
          <Datagrid rowStyle={rowStyle}>
            <FunctionField
              label="Bike"
              render={item => {
                return `${item.typeVehicle == 1 ? "Van" : "Bike"} ${item.model_name}, ${item.licence_plate}, ${item.vehicle_color != null ? item.vehicle_color : ''}`;
              }}
            />
            <TextField label="KM" source="vehicle_mileage" sortable={true} />
            <FunctionField
              sortable={true}
              label="Km Due"
              render={item => {
                if (item.typeVehicle == 2) {
                  if (item.km_due > 0) {
                    return <font style={{ color: "red" }}><span class="alert-icon-danger"></span> {item.km_due}</font>;
                  }
                  else if (item.km_due <= 0 && item.km_due >= -1000) {
                    return <font style={{ color: "black" }}><span class="alert-icon-success"></span> {item.km_due}</font>;
                  }
                  else {
                    return <font style={{ color: "black" }}><span class="alert-icon-warning"></span> {item.km_due}</font>;
                  }
                }
                else {
                  if (item.typeVehicle == 1) {
                    const ProximoMantenim = item.vehicle_mileage - (item.last_km_revision + 15000)
                    //  const antMantenim = item.maintenances
                    const kmDue = ProximoMantenim
                    if (kmDue > 0) {
                      return <font style={{ color: "red" }}><span class="alert-icon-danger"></span> {kmDue}</font>;
                    }
                    else if (kmDue <= 0 && kmDue >= -1000) {
                      return <font style={{ color: "black" }}><span class="alert-icon-success"></span> {kmDue}</font>;
                    }
                    else {
                      return <font style={{ color: "black" }}><span class="alert-icon-warning"></span> {kmDue}</font>;
                    }
                  }
                  else {
                    return `***${item.km_due}`;
                  }
                }
              }}
            />

            <Buttons />
          </Datagrid>
        }
        medium={
          <Datagrid rowStyle={rowStyle}>
            <FunctionField
              label="Bike"
              render={item => {
                return `${item.typeVehicle == 1 ? "Van" : "Bike"} ${item.model_name}, ${item.licence_plate}, ${item.vehicle_color != null ? item.vehicle_color : ''}`;
              }}
            />

            <TextField
              label="City"
              source="lastLocation.location_name"
              sortable={false}
            />
            <TextField label="KM" source="vehicle_mileage" sortable={true} />
            <TextField label="Last maintenances" source="maintenances" sortable={true} />
            {/*   <TextField
              label="Due (Km)"
              source="last_km_revision"
              sortable={true}
            /> */}
            <FunctionField
              label="Due (Km)"
              render={item => {
                //se agrega solo a los que son tipo vans su proximo periodo no a los 10mil sino a los 25mil 
                // op normal de consulta proximo es a 10mil sumamos 15mil para cuadrar resultado solo para vans
                if (item.typeVehicle == 1) {
                  return `${item.last_km_revision + 15000}`;
                }
                else {
                  if (item.last_km_revision == '11000') {
                    return `${item.last_km_revision - 1000}`;
                  }
                  else{
                    return `${item.last_km_revision}`;
                  }
                }
              }}
            />

            <FunctionField
              sortable={true}
              label="Km Due"
              render={item => {
                if (item.typeVehicle == 2) {
                  if (item.km_due > 0) {
                    if (item.last_km_revision == '11000') {
                      return <font style={{ color: "red" }}><span className="alert-icon-danger"></span> {item.km_due + 1000}</font>;
                    }
                    else{
                      return <font style={{ color: "red" }}><span className="alert-icon-danger"></span> {item.km_due}</font>;
                    }
                  }
                  else if (item.km_due <= 0 && item.km_due <= -1000) {
                    return <font style={{ color: "black" }}><span className="alert-icon-success"></span> {item.km_due}</font>;
                  }
                  else {
                    return <font style={{ color: "black" }}><span className="alert-icon-warning"></span> {item.km_due}</font>;
                  }
                }
                else {
                  if (item.typeVehicle == 1) {
                    const ProximoMantenim = item.vehicle_mileage - (item.last_km_revision + 15000)
                    //  const antMantenim = item.maintenances
                    const kmDue = ProximoMantenim
                    if (kmDue > 0) {
                      return <font style={{ color: "red" }}><span className="alert-icon-danger"></span> {kmDue}</font>;
                    }
                    else if (kmDue <= 0 && kmDue <= -1000) {
                      return <font style={{ color: "black" }}><span className="alert-icon-success"></span> {kmDue}</font>;
                    }
                    else {
                      return <font style={{ color: "black" }}><span className="alert-icon-warning"></span> {kmDue}</font>;
                    }
                  }
                  else {
                    return `***${item.km_due}`;
                  }
                }
              }}
            />

            <Buttons />
          </Datagrid>
        }
      />
    </List>
  );
};

const Buttons = ({ record = {} }) => {
  if (isEmpty(record.ongoingMaintenance)) {
    return (
      <div>
        <Button
          component={Link}
          style={{ width: "100px" }}
          to={{
            pathname: `/vehicles/${record.id}/3`
          }}
          target="_blank"
          label="Create"
        >
          <Add />
        </Button>
      </div>
    );
  }
  return (
    <div>
      <EditButton
        to={{
          pathname: `/maintenances/${prop(
            "id",
            head(record.ongoingMaintenance)
          )}`
        }}
        target="_blank"
        record={record}
        label="Edit"
        style={{ width: "100px" }}
      />

      <CloseMaintenanceButton record={head(record.ongoingMaintenance)} />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/resources/maintenancesDue.js